import { useRef } from 'react'
import classes from './Game.module.scss'
import { useSelector } from 'react-redux';
import { forwardRef, useImperativeHandle } from 'react';
import { motion, useAnimate } from "framer-motion"
import { YesNoButton } from './components/Card/YesNoButton';
import { Card } from './components/Card';
import DeckCards from './components/Deck';
import clsx from 'clsx';
import { CONTENT_TYPE } from '@educaplay/core';

const Game = forwardRef(function Game({ onAnswer }, ref) {
  const questions = useSelector(state => state.game.questions).map(question => {
    return {
      ...question,
      imgSrc: question.media?.type === CONTENT_TYPE.IMAGE ? question.media.src : null,
      audioSrc: question.media?.type === CONTENT_TYPE.AUDIO ? question.media.src : null,
    }
  });
  const lives = useSelector(state => state.game.lives)
  const isCompleteEntryAnimation = useSelector(state => state.game.isCompleteEntryAnimation);
  const [cardRef, animateCard] = useAnimate();
  const [cardClone1Ref, animateCardClone1] = useAnimate();
  const [cardClone2Ref, animateCardClone2] = useAnimate();
  const [yesRef, animateYes] = useAnimate();
  const [noRef, animateNo] = useAnimate();
  const deckCardsRef = useRef({});

  const firstQuestion = questions[0];

  useImperativeHandle(ref, () => ({
    animateEntry: async () => {
    
      animateCard(cardRef.current, { y: "0%" }, { duration: .75, type: "spring" });
      animateCardClone1(cardClone1Ref.current, { y: "0%" }, { duration: .5, type: "spring", delay: .15 });
      animateCardClone2(cardClone2Ref.current, { y: "0%" }, { duration: .6, type: "spring", delay: .3 });

      animateNo(noRef.current, { opacity: 1, scale: 1}, {delay: .4, duration: .4, type: "spring" });
      await animateYes(yesRef.current,{ opacity: 1, scale: 1 }, { duration: .4, type: "spring", delay: .65 });

    },

    animateFail: async () => {
      await deckCardsRef.current.fail();
    }
  }));

  return (
    <div className={clsx(classes.game, lives === 0 && classes.notInteractuable)}>
    {!isCompleteEntryAnimation && (
      <>
        <div className={classes.cardContainer}>
          <motion.div ref={cardClone1Ref} initial={{ y: "-150%" }} className={classes.deck} style={{ position: "relative", zIndex: 1 }}>
            <div className={classes.emptyCard} />
          </motion.div>

          <motion.div ref={cardClone2Ref} initial={{ y: "-150%" }} className={classes.deck} style={{ position: "relative", zIndex: 1 }}>
            <div className={classes.emptyCard} />
          </motion.div>
          <motion.div initial={{ y: "-150%" }} ref={cardRef} className={classes.deck} style={{ position: "relative", zIndex: 2 }}>
            <Card 
              className={classes.animateCard}
              text={firstQuestion.text}
              imgSrc={firstQuestion.imgSrc}
              audioSrc={ firstQuestion.audioSrc}
              freezed
            />

            <div className={classes["button-yesno-container"]}>
              <motion.div ref={noRef} initial={{ opacity: 0, scale: .2 }}>
                <YesNoButton disabled variant="no" />
              </motion.div>

              <motion.div ref={yesRef} initial={{ opacity: 0, scale: .2 }}>
                <YesNoButton disabled variant="yes" />
              </motion.div>
            </div>
          </motion.div>
        </div>
      </>
    )}

    {isCompleteEntryAnimation && (
      <DeckCards
        ref={deckCardsRef}
        questions={questions}
        onAnswer={onAnswer}
        />
    )}
  </div>
  )
})

export default Game

